// hook dependancies
import { useGlobal, setGlobal } from "reactn";

/**
 * Hook for login / register functions
 */
const LoginHook = () => {
    const [values] = useGlobal("values");

    const setLoginData = loginData => {
        const { loggedIn, ciamUserId } = loginData;
        setGlobal({
            values: {
                ...values,
                loggedIn,
                ciamUserId,
                userIsVerified: loginData.isVerified,
                loginChecked: true
            }
        });
    };

    const openLoginModal = e => {
        e.preventDefault();

        window.newLogin = true;

        if (window.M78) {
            window.M78.openLoginRegistration("AP-login");
        }
    };

    const openSignupModal = e => {
        e.preventDefault();

        window.newLogin = true;

        if (window.M78) {
            window.M78.openLoginRegistration("AP-reg");
        }
    };

    // returning all varaibles and functions that we can to use inside other components
    return {
        setLoginData,
        openLoginModal,
        openSignupModal
    };
};

export default LoginHook;
